import { getMetricLenderApplicationViewsByCriteria } from '@nemuru-eng/js-api-client';

import { useCache } from '@/hooks/requests/useCache';

export const useGetMetricLenderApplicationViewsByCriteria = (query: string) => {
  const { data, loading, error, revalidate } = useCache(getMetricLenderApplicationViewsByCriteria, { query });

  return {
    metricLenderApplicationViews: data,
    metricLenderApplicationViewsLoading: loading,
    metricLenderApplicationViewsError: error,
    revalidateMetricLenderApplicationViews: revalidate,
  };
};
